import { queryClient as defaultQueryClient } from '@/plugins/vueQuery';
import type { QueryInvalidationParams } from '@/types/query';
import { queryKeys } from '@/utils/constants';
import { getAgreementAthletesQueryKey } from '@/utils/queries/agreements';
import { getTeamBudgetQueryKey, getBudgetGroupQueryKey } from '@/utils/queries/budgets';
import { getEligibleAthletesQueryKey } from '@/utils/queries/athletes';

const MODULE_KEY = 'teams';

/** Query Key Getters */

export const getTeamsQueryKey = () => [MODULE_KEY, queryKeys.ALL_TEAMS];

export const getTeamPositionsQueryKey = (teamTwrn?: string | null) => {
  const key = [MODULE_KEY, queryKeys.TEAM_POSITIONS];
  if (teamTwrn) {
    key.push(teamTwrn);
  }
  return key;
};

export const getTagsQueryKey = (orgTwrn?: string | null, teamTwrn?: string | null) => {
  const key = [MODULE_KEY, queryKeys.TAGS];
  if (orgTwrn) {
    key.push(orgTwrn);
    if (teamTwrn) {
      key.push(teamTwrn);
    }
  }

  return key;
};

/** Invalidation Helpers */

/**
 * Invalidates queries that embed or display athlete tags outside the tags module:
 * team budget details, agreement athletes, eligible athletes, and budget groups.
 */
export const invalidateQueriesWithTags = (
  teamTwrn?: string | null,
  options?: QueryInvalidationParams,
) => {
  const client = options?.queryClient ?? defaultQueryClient;

  client.invalidateQueries({ queryKey: getTeamBudgetQueryKey(teamTwrn) });
  // Bust the full agreement-athletes cache — tags can appear on any agreement
  client.invalidateQueries({ queryKey: getAgreementAthletesQueryKey() });
  client.invalidateQueries({ queryKey: getEligibleAthletesQueryKey(teamTwrn) });
  client.invalidateQueries({ queryKey: getBudgetGroupQueryKey(teamTwrn) });
};
